module.exports = __webpack_public_path__ + "static/favicon-96x96-ad6ef1ec91f535771b28dd25cb606679.png";